(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[372],{

/***/ 7267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ TitleAndMetaTags; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _data_siteMetadata__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1576);
/* harmony import */ var _data_siteMetadata__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_data_siteMetadata__WEBPACK_IMPORTED_MODULE_4__);





function TitleAndMetaTags(props) {
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const title = props.title || (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_4___default().title);
    const description = props.description || (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_4___default().description);
    const image = props.image || (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_4___default().socialBanner);
    const url =  false ? 0 : window.location.origin;
    const imageUrl = "".concat(url).concat(image);
    const path = props.pathname || router.pathname;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: "".concat(url).concat(path)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: imageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: "@humanloop"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            })
        ]
    });
}


/***/ }),

/***/ 6400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ BadgeShade; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_classNames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5368);
/* harmony import */ var _Badge_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2861);
/* harmony import */ var _Badge_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Badge_module_css__WEBPACK_IMPORTED_MODULE_2__);



var BadgeShade;
(function(BadgeShade) {
    BadgeShade["Gray"] = "gray";
    BadgeShade["LightGray"] = "light-gray";
    BadgeShade["Blue"] = "blue";
    BadgeShade["LightBlue"] = "light-blue";
    BadgeShade["Cyan"] = "cyan";
    BadgeShade["Purple"] = "purple";
    BadgeShade["Navy"] = "navy";
    BadgeShade["Orange"] = "orange";
    BadgeShade["Pink"] = "pink";
    BadgeShade["Yellow"] = "yellow";
    BadgeShade["Green"] = "green";
    BadgeShade["Red"] = "red";
})(BadgeShade || (BadgeShade = {}));
const Badge = (param)=>{
    let { className , size =16 , shade ="gray" , children  } = param;
    const classes = {
        base: "flex justify-center items-center rounded-full px-[5px] py-1 text-center font-bold",
        size: {
            16: "min-w-[16px] h-16 text-11-16",
            20: "min-w-[20px] h-20 text-12-14",
            24: "min-w-[24px] h-24 text-14-16"
        },
        shade: {
            ["gray"]: "bg-gray-400 text-gray-900",
            ["light-gray"]: "bg-gray-300 text-gray-700",
            ["blue"]: "bg-blue-600 text-white ",
            ["light-blue"]: "bg-blue-200 text-blue-600",
            ["cyan"]: "bg-cyan-300 text-cyan-800",
            ["purple"]: "bg-purple-300 text-purple-800",
            ["navy"]: "bg-navy-300 text-navy-800",
            ["orange"]: "bg-orange-300 text-orange-800",
            ["pink"]: "bg-pink-300 text-pink-800",
            ["yellow"]: "bg-yellow-300 text-yellow-800",
            ["green"]: "bg-green-300 text-green-800",
            ["red"]: "bg-red-300 text-red-800"
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_utils_classNames__WEBPACK_IMPORTED_MODULE_1__/* .classNames */ .A)((_Badge_module_css__WEBPACK_IMPORTED_MODULE_2___default().badge), classes.base, classes.size[size], classes.shade[shade], className),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Badge);


/***/ }),

/***/ 8372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ platform_Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./components/TitleAndMetaTags.tsx
var TitleAndMetaTags = __webpack_require__(7267);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/library/Badge.tsx
var Badge = __webpack_require__(6400);
// EXTERNAL MODULE: ./components/library/Logos.tsx
var Logos = __webpack_require__(6786);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(8680);
// EXTERNAL MODULE: ./components/platform/NewsletterSignUp.tsx
var NewsletterSignUp = __webpack_require__(3360);
;// CONCATENATED MODULE: ./components/platform/Footer.tsx





const FooterLinks = {
    Resources: [
        {
            title: "Blog",
            url: "/blog"
        }
    ],
    Company: [
        {
            title: "Careers",
            display: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "flex items-center gap-8",
                children: [
                    "Careers ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                        children: "5"
                    })
                ]
            }),
            url: constants/* CAREERS_LINK */.Fg
        },
        {
            title: "About",
            url: constants/* ABOUT_PAGE_LINK */.Kx
        }
    ],
    Product: [],
    Social: [
        {
            title: "Twitter",
            url: constants/* TWITTER_LINK */.v
        },
        {
            title: "GitHub",
            url: constants/* GITHUB_LINK */.$t
        },
        {
            title: "LinkedIn",
            url: constants/* LINKEDIN_LINK */.at
        }
    ]
};
const Footer = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container-xl flex flex-col items-start justify-between gap-y-32 py-60 sm:py-120 xl:flex-row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mr-120 grow",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logos/* HumanloopLogo */.k, {
                            className: "h-28 shrink-0"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "grid w-full shrink grid-cols-2 gap-y-32 md:grid-cols-4",
                        children: Object.entries(FooterLinks).map((param)=>/*#__PURE__*/ {
                            let [section, links] = param;
                            return (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col justify-start gap-8 text-14-20",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-gray-600",
                                        children: section
                                    }),
                                    links.map((param)=>/*#__PURE__*/ {
                                        let { title , url , display  } = param;
                                        return (0,jsx_runtime.jsx)("a", {
                                            href: url,
                                            className: "text-gray-900 hover:underline",
                                            children: display || title
                                        }, title);
                                    })
                                ]
                            }, section);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "grow",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsletterSignUp/* default */.Z, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "shrink",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container-xl flex justify-between gap-12 border-t border-gray-300 py-24 text-11-14 text-gray-600 sm:py-36 sm:text-14-16",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: "\xa9 2020 - 2045 Humanloop, Inc."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex gap-32",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "/terms",
                                    className: "hover:text-gray-900",
                                    children: "Terms"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "/privacy",
                                    className: "hover:text-gray-900",
                                    children: "Privacy"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/popover/popover.js + 11 modules
var popover = __webpack_require__(4061);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 6 modules
var transition = __webpack_require__(7913);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/MenuIcon.js
var MenuIcon = __webpack_require__(9065);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/ArrowLeftIcon.js
var ArrowLeftIcon = __webpack_require__(5287);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/XIcon.js
var XIcon = __webpack_require__(5506);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/ArrowRightIcon.js
var ArrowRightIcon = __webpack_require__(1335);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/ChevronDownIcon.js
var ChevronDownIcon = __webpack_require__(3342);
// EXTERNAL MODULE: ./components/library/Button.tsx + 1 modules
var Button = __webpack_require__(1317);
// EXTERNAL MODULE: ./components/library/IconButton.tsx
var IconButton = __webpack_require__(1172);
// EXTERNAL MODULE: ./components/library/Icons.tsx
var Icons = __webpack_require__(4305);
// EXTERNAL MODULE: ./components/library/utils/classNames.ts
var classNames = __webpack_require__(5368);
// EXTERNAL MODULE: ./hooks/useBreakpoints.ts
var useBreakpoints = __webpack_require__(7921);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./components/platform/Header.tsx















const isNestedLink = (item)=>{
    return "items" in item;
};
const headerLinks = [
    // {
    //   name: "Products",
    //   items: [
    //     {
    //       name: "Programmatic",
    //       description: "Powerful weak labeling",
    //       href: "/programmatic",
    //       Icon: Lissajous5Icon,
    //     },
    //     {
    //       name: "Platform",
    //       description: "Annotation, training and deployment",
    //       href: "#",
    //       Icon: Lissajous2Icon,
    //     },
    //   ],
    // },
    {
        name: "About",
        href: "/about"
    },
    {
        name: "Blog",
        href: "/blog"
    },
    {
        name: "Careers",
        href: constants/* CAREERS_LINK */.Fg,
        external: true,
        display: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            className: "flex items-center gap-x-8 opacity-80 hover:opacity-100",
            children: [
                "Careers",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                    shade: Badge/* BadgeShade.Blue */.Y.Blue,
                    className: "hidden text-11-14 md:block",
                    children: "5"
                })
            ]
        })
    }
];
const Header = ()=>{
    const { isMediumWidth  } = (0,useBreakpoints/* useBreakpoints */.k)();
    const router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover */.J, {
        className: "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container-xl mx-auto flex w-full items-center justify-between py-20 md:py-40",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        href: constants/* HOMEPAGE_LINK */.fm,
                        styling: "ghost",
                        className: "-ml-10",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logos/* HumanloopLogo */.k, {
                            className: " -mb-4 h-28 text-gray-900 "
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-8",
                        children: [
                            headerLinks.map((item)=>isNestedLink(item) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderDropdown, {
                                    name: item.name,
                                    items: item.items
                                }, item.name) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                    href: item.href,
                                    size: isMediumWidth ? 32 : 24,
                                    className: "group flex-none",
                                    styling: "ghost",
                                    active: router.pathname.startsWith(item.href),
                                    square: true,
                                    target: item.external ? "_blank" : undefined,
                                    IconRight: item.external ? (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "invisible relative top-2 right-2 transition-all group-hover:visible group-hover:top-0 group-hover:right-0 group-hover:opacity-100",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ArrowUpRightIcon */.fC, {
                                                ...props
                                            })
                                        }) : undefined,
                                    children: [
                                        item.display ? item.display : item.name,
                                        item.badge && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                                            shade: Badge/* BadgeShade.Blue */.Y.Blue,
                                            children: item.badge
                                        })
                                    ]
                                }, item.name)),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                href: constants/* HUMANLOOP_APP_LOGIN */.t9,
                                size: isMediumWidth ? 32 : 24,
                                className: isMediumWidth ? "flex-none" : "hidden",
                                styling: "ghost",
                                square: true,
                                children: "Sign in"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                href: constants/* LLM_TYPEFORM */.iA,
                                styling: isMediumWidth ? "solid" : "outline",
                                size: isMediumWidth ? 32 : 24,
                                shade: Button/* ButtonShade.Blue */.B.Blue,
                                square: true,
                                className: "flex-none",
                                children: "Get started"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Button */.J.Button, {
                                className: "-my-8 md:hidden" // neg margin to not expand button height next to this.
                                ,
                                as: IconButton/* default */.Z,
                                shade: IconButton/* IconButtonShade.Blue */.f.Blue,
                                Icon: MenuIcon/* default */.Z,
                                size: 40,
                                square: true
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                as: react.Fragment,
                enter: "duration-200 ease-out",
                enterFrom: "opacity-0 scale-95",
                enterTo: "opacity-100 scale-100",
                leave: "duration-100 ease-in",
                leaveFrom: "opacity-100 scale-100",
                leaveTo: "opacity-0 scale-95",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Panel */.J.Panel, {
                    focus: true,
                    className: "absolute inset-x-0 top-0 bottom-0 z-[60] origin-top-right transform transition md:hidden",
                    children: (param)=>/*#__PURE__*/ {
                        let { close  } = param;
                        return (0,jsx_runtime.jsx)(MobileMenu, {
                            links: headerLinks,
                            close: close
                        });
                    }
                })
            })
        ]
    });
};
const HeaderDropdown = (param)=>{
    let { name , items  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Group */.J.Group, {
        as: "nav",
        className: "hidden md:flex",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover */.J, {
            className: "relative",
            children: (param)=>/*#__PURE__*/ {
                let { open  } = param;
                return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Button */.J.Button, {
                            as: Button/* default */.Z,
                            styling: "ghost",
                            square: true,
                            active: open,
                            IconRight: ChevronDownIcon/* default */.Z,
                            children: name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                            as: react.Fragment,
                            enter: "transition ease-out duration-200",
                            enterFrom: "opacity-0 translate-y-1",
                            enterTo: "opacity-100 translate-y-0",
                            leave: "transition ease-in duration-150",
                            leaveFrom: "opacity-100 translate-y-0",
                            leaveTo: "opacity-0 translate-y-1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Panel */.J.Panel, {
                                className: "absolute z-10 mt-12 -ml-16 w-screen max-w-md transform px-4 sm:px-0 lg:left-1/2 lg:ml-0 lg:-translate-x-1/2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "overflow-hidden rounded-lg border border-gray-400 bg-white shadow-b",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "relative grid gap-12 bg-white px-8 py-12",
                                        children: items.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                href: item.href,
                                                className: "flex items-start gap-12 rounded px-12 py-8 hover:bg-gray-200",
                                                children: [
                                                    item.Icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(item.Icon, {
                                                        className: "h-32 w-32 flex-shrink-0",
                                                        "aria-hidden": "true"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "ml-4 flex flex-col gap-4",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text-14-16 text-gray-900",
                                                                children: item.name
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: " text-14-16 text-gray-600",
                                                                children: item.description
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, item.name))
                                    })
                                })
                            })
                        })
                    ]
                });
            }
        })
    });
};
const MobileMenu = (param)=>{
    let { links , close  } = param;
    const [currentLinks, setCurrentLinks] = (0,react.useState)(links);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex h-full flex-col justify-between gap-20 bg-blue ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center justify-between p-12 ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    IconLeft: ArrowLeftIcon/* default */.Z,
                                    size: 40,
                                    square: true,
                                    styling: "ghost",
                                    className: (0,classNames/* classNames */.A)("text-white hover:border-blue hover:text-white", JSON.stringify(currentLinks) === JSON.stringify(links) ? "hidden" : ""),
                                    onClick: ()=>setCurrentLinks(links),
                                    children: "Back"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Button */.J.Button, {
                                as: IconButton/* default */.Z,
                                Icon: XIcon/* default */.Z,
                                size: 40,
                                square: true,
                                className: " text-white hover:border-blue hover:text-blue"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-20 px-12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                            className: "grid gap-y-4",
                            children: currentLinks.map((link)=>{
                                return isNestedLink(link) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    onClick: ()=>{
                                        setCurrentLinks(link === null || link === void 0 ? void 0 : link.items);
                                    },
                                    className: "flex items-center gap-8 border border-transparent px-12 py-6 text-left text-32-40 font-bold tracking-wide text-white transition-all hover:gap-24 hover:border-white hover:text-white",
                                    children: [
                                        link.name,
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightIcon/* default */.Z, {
                                            className: "h-32 w-32"
                                        })
                                    ]
                                }, link.name) : /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                    href: link.href,
                                    target: link.external ? "_blank" : undefined,
                                    onClick: ()=>{
                                        close();
                                    },
                                    className: "flex items-center gap-8 border border-transparent px-12 py-6 text-left text-32-40 font-bold tracking-wide text-white hover:border-white hover:text-white",
                                    children: [
                                        link.name,
                                        link.external && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ArrowUpRightIcon */.fC, {
                                            className: "h-32 w-32 text-white"
                                        })
                                    ]
                                }, link.name);
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mx-24 mb-32",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    block: true,
                    size: 52,
                    styling: "outline",
                    square: true,
                    href: constants/* HUMANLOOP_APP_LOGIN */.t9,
                    className: "border-blue-500 text-white hover:text-white",
                    children: "Sign in"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/platform/Layout.tsx





const Layout = (props)=>{
    const [bannerOpen, setBannerOpen] = (0,react.useState)(true);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            "noTags" in props ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleAndMetaTags/* TitleAndMetaTags */.H, {
                ...props
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {}),
            props.children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {})
        ]
    });
};
/* harmony default export */ var platform_Layout = (Layout);


/***/ }),

/***/ 3360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9700);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_hot_toast__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4931);
/* harmony import */ var services_analytics_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2554);
/* harmony import */ var services_api_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1506);
/* harmony import */ var _library_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1317);
/* harmony import */ var _library_Icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4305);
/* harmony import */ var _library_utils_classNames__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5368);









const NewsletterSignUp = (param)=>{
    let { shade  } = param;
    const buttonText = "Subscribe";
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [form, setForm] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        email: ""
    });
    const [signedUp, setSignedUp] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setLoading(true);
        services_analytics_service__WEBPACK_IMPORTED_MODULE_2__/* .Analytics.identify */ .cp.identify(form.email, {
            email: form.email
        });
        services_analytics_service__WEBPACK_IMPORTED_MODULE_2__/* .Analytics.track */ .cp.track(services_analytics_service__WEBPACK_IMPORTED_MODULE_2__/* .EventObject.Form */ .fC.Form, services_analytics_service__WEBPACK_IMPORTED_MODULE_2__/* .EventAction.Submitted */ .AO.Submitted, {
            form: "newsletter-signup",
            email: form.email
        });
        try {
            const result = await services_api_service__WEBPACK_IMPORTED_MODULE_3__/* .ApiService.post */ .s.post("/api/newsletter-signup", form, {}, (e, method, url, data, config)=>{
                var ref, ref1;
                const message = e === null || e === void 0 ? void 0 : (ref = e.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message;
                console.log("Failed to fetch:", e, method, url, data, config);
                if (message) {
                    react_hot_toast__WEBPACK_IMPORTED_MODULE_6__/* ["default"].error */ .ZP.error(message);
                }
            });
            if (result.status === 200) {
                setSignedUp(true);
            }
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col gap-16 sm:min-w-[350px]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-14-20 text-gray-600",
                children: "Subscribe to our newsletter. Stay in the loop."
            }),
            signedUp ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "border-b border-gray-400",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex h-[44px] items-center py-8 text-14-20 text-gray-800 md:h-52",
                    children: "Successfully subscribed!"
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("form", {
                onSubmit: handleSubmit,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex justify-center gap-12 border-b border-gray-400",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "relative grow rounded",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "pointer-events-none absolute inset-y-0 left-0 flex items-center pl-12",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_outline__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    className: "h-24 w-24 text-gray-400",
                                    "aria-hidden": "true"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                type: "email",
                                name: "email",
                                id: "email",
                                required: true,
                                className: "form-input block h-[44px] w-full border-0 pl-48 pr-[140px] text-14-20 text-black ring-0 focus:ring-0 md:h-52",
                                placeholder: "your email",
                                value: form.email,
                                onChange: (e)=>{
                                    setForm({
                                        ...form,
                                        email: e.target.value
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "absolute inset-y-0 right-0 flex items-center",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_library_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    type: "submit",
                                    styling: "ghost",
                                    shade: _library_Button__WEBPACK_IMPORTED_MODULE_4__/* .ButtonShade.Gray */ .B.Gray,
                                    className: (0,_library_utils_classNames__WEBPACK_IMPORTED_MODULE_8__/* .classNames */ .A)(shade === "black" && "!bg-black", "whitespace-nowrap", loading ? "pl-20 pr-16" : "px-32", "!font-normal"),
                                    square: true,
                                    loading: loading,
                                    IconRight: loading ? _library_Icons__WEBPACK_IMPORTED_MODULE_5__/* .LoadingIcon */ .Ho : undefined,
                                    size: 40,
                                    children: buttonText
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NewsletterSignUp);


/***/ }),

/***/ 7921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ useBreakpoints; }
/* harmony export */ });
/* harmony import */ var usehooks_ts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5339);

// Media breakpoints with same widths as Tailwind CSS
const useBreakpoints = ()=>{
    const { width , height  } = (0,usehooks_ts__WEBPACK_IMPORTED_MODULE_0__/* .useWindowSize */ .iP)();
    const isLessThanSmallWidth = width < 640;
    const isSmallWidth = width >= 640;
    const isMediumWidth = width >= 768;
    const isLargeWidth = width >= 1024;
    return {
        width,
        isLessThanSmallWidth,
        isSmallWidth,
        isMediumWidth,
        isLargeWidth
    };
};


/***/ }),

/***/ 1506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s": function() { return /* binding */ ApiService; }
});

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/react-hot-toast.esm.js + 1 modules
var react_hot_toast_esm = __webpack_require__(4931);
;// CONCATENATED MODULE: ./components/ToastErrorHandler.tsx


const ErrorToast = (param)=>{
    let { message , method , url  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            message,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "text-11-14 text-gray-700",
                children: [
                    method,
                    " on ",
                    url
                ]
            })
        ]
    });
};
const toastErrorHandler = (e, method, url, data, config)=>{
    console.log("Failed to fetch:", e, method, url, data, config);
    if (e.message) {
        react_hot_toast_esm/* default.error */.ZP.error(/*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorToast, {
            message: e.message,
            method: method,
            url: url
        }), {
            duration: 8000
        });
    }
};

;// CONCATENATED MODULE: ./services/api.service.ts
/**
 * This module contains centralized definitions for making API requests from the
 * frontend.
 *
 */ 

const request = async function(method, url) {
    let data = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, config = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, onError = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : toastErrorHandler;
    const instance = axios_default().create({});
    try {
        return await instance({
            method,
            url,
            data,
            ...config
        });
    } catch (e) {
        onError(e, method, url, data, config);
        throw e;
    }
};
const get = function(url) {
    let config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, onError = arguments.length > 2 ? arguments[2] : void 0;
    return request("GET", url, {}, config, onError);
};
const post = function(url, data) {
    let config = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, onError = arguments.length > 3 ? arguments[3] : void 0;
    return request("POST", url, data, config, onError);
};
const put = function(url, data) {
    let config = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, onError = arguments.length > 3 ? arguments[3] : void 0;
    return request("PUT", url, data, config, onError);
};
const patch = function(url, data) {
    let config = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, onError = arguments.length > 3 ? arguments[3] : void 0;
    return request("PATCH", url, data, config, onError);
};
const remove = function(url) {
    let config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, onError = arguments.length > 2 ? arguments[2] : void 0;
    return request("DELETE", url, {}, config, onError);
};
// SWR shim which resolves the response data
// for the caller
const getJSON = async (url)=>{
    const response = await get(url);
    return response.data;
};
const ApiService = {
    get,
    post,
    put,
    patch,
    remove,
    getJSON
};


/***/ }),

/***/ 2861:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"badge":"Badge_badge__BhXFn"};

/***/ })

}]);